import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { MarketplaceIntroSlideLayout } from "./MarketplaceIntroSlideLayout";

interface EducationIntroSlideProps {
  marketplaceType: "shifts" | "jobs";
}

export function EducationIntroSlide(props: EducationIntroSlideProps) {
  const { marketplaceType } = props;

  return (
    <MarketplaceIntroSlideLayout>
      <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
        <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
          Welcome to
        </Title>
        <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
          Clipboard
        </Title>
      </Stack>

      <Text variant="body1">Take a tour of our {marketplaceType} marketplace</Text>
    </MarketplaceIntroSlideLayout>
  );
}
